var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spnod-admin__form--container container pl-0 mx-0 d-flex flex-column"
  }, [_c('b-form', {
    staticClass: "d-flex flex-column",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2",
    attrs: {
      "name": "name",
      "state": _vm.validateState('name'),
      "type": "text",
      "placeholder": "Name",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.name.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.name, "$model", $$v)
      },
      expression: "$v.form.name.$model"
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.options,
      "multiple": true,
      "close-on-select": false,
      "placeholder": "Share with",
      "track-by": "_id",
      "label": "name",
      "group-select": true,
      "group-values": "values",
      "group-label": "label"
    },
    model: {
      value: (_vm.form.sharedWith),
      callback: function($$v) {
        _vm.$set(_vm.form, "sharedWith", $$v)
      },
      expression: "form.sharedWith"
    }
  }), _vm._v(" "), _c('b-form-textarea', {
    staticClass: "mb-4",
    attrs: {
      "name": "description",
      "state": _vm.validateState('description'),
      "type": "text",
      "rows": "3",
      "placeholder": "Description",
      "size": "sm"
    },
    model: {
      value: (_vm.$v.form.description.$model),
      callback: function($$v) {
        _vm.$set(_vm.$v.form.description, "$model", $$v)
      },
      expression: "$v.form.description.$model"
    }
  }), _vm._v(" "), _c('b-form-row', {
    staticClass: "d-flex justify-content-between px-1"
  }, [_c('b-form-group', [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: (_vm.modals.delete._id),
      expression: "modals.delete._id"
    }],
    staticClass: "bg-danger",
    attrs: {
      "size": "sm"
    }
  }, [(!_vm.isDeleting) ? _c('p', [_vm._v("Delete")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('b-form-group', {
    staticClass: "d-flex justify-content-end flex-grow"
  }, [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: (_vm.modals.save._id),
      expression: "modals.save._id"
    }],
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm",
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [(!_vm.isSaving) ? _c('p', [_vm._v("Save")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "_id": _vm.modals.save._id,
      "message": _vm.modals.save.message
    },
    on: {
      "success": _vm.handleSubmit
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "_id": _vm.modals.delete._id,
      "message": _vm.modals.delete.message
    },
    on: {
      "success": _vm.handleDelete
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f50f6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/EditFileForm.vue
// module id = y2vU
// module chunks = 2